import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL + "/coupon";

const getCoupons = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

const createCoupons = async (coupon: any) => {
  try {
    const response = await axios.post(API_URL, coupon);
    if (response.status === 201) {
      return {
        success: true,
        message: "Coupon details created successfully",
      };
    }
  } catch (error) {
    console.log("create coupon error " + error);
    return { success: false, message: handleError(error) };
  }
};

const updateCoupon = async (id: number, coupon: any) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, coupon);
    if (response.status === 200) {
      return {
        success: true,
        message: "Coupon details updated successfully",
      };
    }
  } catch (error) {
    return { success: false, message: handleError(error) };
  }
};

const deleteCoupon = async (id: number) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    if (response.status === 200) {
      return {
        success: true,
        message: "Coupon details deleted successfully",
      };
    }
  } catch (error) {
    return { success: false, message: handleError(error) };
  }
};

const handleError = (error: any) => {
  if (axios.isAxiosError(error)) {
    if (!error.response) {
      return "Network error. Please check your internet connection.";
    } else {
      return `Error: ${error.response.status} - ${error.response.data}`;
    }
  } else {
    return "An unexpected error occurred:";
  }
};

export { getCoupons, createCoupons, updateCoupon, deleteCoupon };
